export const DUTCH = 'Dutch';
export const ENGLISH = 'English';
export const FRENCH = 'French';
export const GERMAN = 'German';
export const OTHER = 'Other';
